import React, { useCallback, useState } from 'react';
import CommonFilter from '@/pages/benchmark/components/CommonFilter';
import { useFilterSelector } from './useFilterSelector';
import { IFilterValueType } from '@/pages/benchmark/components/Filter/_type';
import './index.scss';

// url会传筛选器参数给详情页，详情页的筛选器数量是由后端接口决定，url参数只用来做值的设置
const MetricDetailFilter = (props: any) => {
  const { children,...resetProps } = props;
  const [filterVal, setFilterVal] = useState<any>(null);
  const {loading, error,  inputList, selectorList} = useFilterSelector({
    config: props?.config
  });
 
  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value: IFilterValueType) => {
    setFilterVal(value);
  }, []);

  const onConfirm = useCallback((value: IFilterValueType) => {
    setFilterVal(value);
  }, []);

  const onReset = useCallback((value: IFilterValueType) => {
    setFilterVal(value);
  }, []);

  return <CommonFilter
    {...resetProps}
    loading={loading}
    error={error}
    selectorList={selectorList}
    value={filterVal}
    inputList={inputList}
    setFilterVal={setFilterVal}
    onInit={onInit}
    onConfirm={onConfirm}
    onReset={onReset}
  >
    {children}
  </CommonFilter>;
};

export default MetricDetailFilter;
